// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as NetworkUtils from "../../../../../library/utils/NetworkUtils.bs.js";
import * as Logger$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/logger/Logger.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as InsuranceRepoConfig from "./InsuranceRepoConfig.bs.js";

var dummyInsurancePlanResponse = {
        status: 200,
        data: {
            "beneficiary_name": "Madhu2",
            "policy_number": "97751248980",
            "policy_start_date": 1664562600,
            "policy_end_date": 1675189799,
            "coverages": [
                {
                    "cover_id": "hospitalization",
                    "sum_insured": 100000
                },
                {
                    "cover_id": "accidental",
                    "sum_insured": 300000
                }
            ]
        }
    };

var dummyInsurancePlanFailure = {
        "status":401,
        "data":{"msg":"Incorrect auth token"}
    };

function fetchInsurancePlanDetails(uuid, _auth_token) {
  Logger$Catalyst.trace({
        requestUrl: "fetchInsurancePlanDetailsApiCalled"
      });
  Logger$Catalyst.debug({
        payload: uuid
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyInsurancePlanResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(InsuranceRepoConfig.InsurancePlanResponseConverter.execute, result);
                            });
                }), "");
}

var InsuranceRepo = {
  dummyInsurancePlanResponse: dummyInsurancePlanResponse,
  dummyInsurancePlanFailure: dummyInsurancePlanFailure,
  fetchInsurancePlanDetails: fetchInsurancePlanDetails
};

export {
  InsuranceRepo ,
  
}
/* NetworkUtils Not a pure module */
